<template>
	<div class="sa-prescrizione-card">
		<div class="sa-prescrizione-header">
			<div>
				<div class="sa-prescrizione-header-title">Terapia Farmacologica</div>
				<div class="sa-prescrizione-header-subtitle">Prescrizione</div>
			</div>
			<!-- <div style="text-align: right">
				<div class="sa-prescrizione-header-subtitle">Velocità</div>
				<div style="font-weight: bold">40 ml/h</div>
			</div> -->
		</div>

		<div class="sa-prescrizione-body">
			<div v-for="(item, index) in prescription.components" :key="index"
				class="sa-prescrizione-item sa-prescrizione-item-farmaco">
				<div class="sa-prescrizione-input-group" style="flex: 3">
					<label class="sa-label-data">Farmaco</label>
					<!-- <input class="sa-prescrizione-input" v-model="item.drugName" placeholder="Cerca farmaco..." /> -->
					<div class="sa-prescrizione-search-wrapper">
						<input class="sa-prescrizione-input sa-prescrizione-input-readonly" v-model="item.prescrizione"
							readonly placeholder="Seleziona un farmaco..." />

						<button @click="openRicercaFamraco(index)" class="sa-prescrizione-btn-search"
							title="Cerca in Federfarma">
							<i class="fas fa-search"></i>
						</button>
					</div>
				</div>

				<div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
					<label class="sa-label-data">Dose</label>
					<input class="sa-prescrizione-input" type="number" v-model="item.quantita" />
				</div>

				<div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
					<label class="sa-label-data">Unità</label>
					<select class="sa-prescrizione-input" v-model="item.unitaMisura"
						@change="onChangeValueUnitaMisura(item)">
						<option v-for="misura of magazzinoArticoliUnitaMisuraBaseOptions" :key="misura.id"
							:value="misura.id">{{
								misura.descrizioneMultiplo }}</option>

					</select>
				</div>
				<div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
					<label class="sa-label-data">Note</label>
					<input class="sa-prescrizione-input" type="text" v-model="item.note" />
				</div>

				<button v-if="!item.veicolo" @click="removeComponent(index)" class="sa-prescrizione-btn-remove">
					<i class="fas fa-trash-alt"></i>
				</button>
			</div>

			<button @click="onClickAggiungiFarmaco" class="sa-prescrizione-btn-add"><i class="fas fa-plus"></i> Aggiungi
				farmaco alla prescrizione</button>
		</div>

		<div class="sa-prescrizione-footer">
			<div class="sa-prescrizione-total-text">
				<!-- Volume Finale: <span class="sa-prescrizione-total-value">{{ totalVolume }} ml</span> -->
			</div>
			<button @click="onClickConfermaPrescrizione" class="sa-prescrizione-btn-confirm">Conferma
				Prescrizione</button>
		</div>
	</div>
</template>

<script>
import MagazzinoMixins from '../../../magazzino/mixins/MagazzinoMixins';
export default {
	mixins: [MagazzinoMixins],
	data() {
		return {
			totalVolume: "",
			selectedIndex: null,
			prescription: {
				components: [
					{ formaFarmaceutica: null, codiceProdotto: null, atcGmp: null, prescrizione: null, quantita: 0, unitaMisura: null, unitaMisuraDescrizione: null, costo: 0.0, veicolo: false },
				],
			},
		};
	},
	mounted() {
		this.mangazzinoArticoliUnitaMisuraLoadData();
	},
	methods: {
		onClickAggiungiFarmaco() {
			this.prescription.components.push({
				formaFarmaceutica: null,
				codiceProdotto: null,
				atcGmp: null,
				prescrizione: "",
				quantita: 0,
				unitaMisura: null,
				costo: 0.0,
				veicolo: false,
			});
		},
		onChangeValueUnitaMisura(item) {
			let unitaMisura = this.magazzinoArticoliUnitaMisuraBaseOptions.filter(e => e.id == item.unitaMisura);
			item.unitaMisuraDescrizione = unitaMisura[0].descrizioneMultiplo;
		},
		openRicercaFamraco(index) {
			this.selectedIndex = index;
			this.$emit("openRicercaFamraco");
		},
		setSelectionFarmaco(schedaFarmaco) {
			this.prescription.components[this.selectedIndex].codiceProdotto = schedaFarmaco.codiceProdotto;
			this.prescription.components[this.selectedIndex].atcGmp = schedaFarmaco.atcGmp;
			this.prescription.components[this.selectedIndex].costo = schedaFarmaco.euroPrezzo1;
			this.prescription.components[this.selectedIndex].formaFarmaceutica = schedaFarmaco.formaFarmaceutica.descrizione;
			this.prescription.components[this.selectedIndex].prescrizione = schedaFarmaco.descrizione;
			let doseUnita = this.parseDrugDose(schedaFarmaco.descrizione);
			//this.prescription.components[this.selectedIndex].quantita = doseUnita.value;
			this.prescription.components[this.selectedIndex].unitaMisura = doseUnita.unit;
		},
		checkIsVehicle(atcCode) {
			if (!atcCode) return false;
			const code = atcCode.toUpperCase();
			const vehiclePrefixes = ["V07AB", "B05B", "B05A"];
			return vehiclePrefixes.some(function (prefix) {
				return code.startsWith(prefix);
			});
		},
		parseDrugDose(description) {
			if (!description) return { value: 0, unit: null };

			var regex = /(\d+(?:[.,]\d+)?)\s*(ML|MG|G|MEQ|UI)/i;
			var match = description.match(regex);

			if (match) {
				return {
					value: parseFloat(match[1].replace(",", ".")),
					unit: match[2].toLowerCase(),
				};
			}
			return { value: 0, unit: "ml" };
		},
		removeComponent: function (index) {
			this.prescription.components.splice(index, 1);
		},
		onClickConfermaPrescrizione() {
			this.$emit("confermaPrescrizione", this.prescription.components);
			this.$bvToast.toast("Prescrizione Confermata", {
				title: "Attenzione",
				autoHideDelay: 3000,
				variant: "success",
			});
		},
		setFarmaci(prescrizioneFarmaci) {
			this.prescription.components = JSON.parse(JSON.stringify(prescrizioneFarmaci));
		},
	},
};
</script>

<style scoped></style>
